(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2915],{

/***/ 5803:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[slug]",
      function () {
        return __webpack_require__(15803);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3091,9803,9583,9037,3059,5648,6066,3077,1023,9572,9529,4193,8388,9765,4547,2510,2047,746,7394,4117,1764,6619,4312,1803,480,9774,2888,179], function() { return __webpack_exec__(5803); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);